<template>
  <div class="mobile+tablet:hidden bg-grey-100">
    <div class="o-wrapper">
      <div
        :class="[
          'h-header-top-mobile lg:h-header-top-desktop flex items-center justify-end list-none',
        ]"
      >
        <nav>
          <ul class="flex items-center list-none lg:flex-nowrap">
            <li
              v-for="(navItem, index) in navItems"
              :key="navItem.id"
              :class="index === 0 ? '' : 'ml-6'"
            >
              <a
                :href="navItem.url"
                :target="navItem.newWindow ? '_blank' : '_self'"
                :class="[
                  'u-body-md group relative inline-block focus:outline-none',
                  navItem.classes,
                  {
                    'cursor-default': !navItem.url,
                  },
                ]"
              >
                <span
                  :class="[
                    'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out',
                  ]"
                ></span>
                <span
                  :class="[
                    'text-grey-800 group-hover:text-primary border-b-2 border-solid group-hover:border-primary border-transparent transition-colors duration-200 ease-in-out',
                  ]"
                >
                  {{ navItem.title }}
                </span>
              </a>
            </li>

            <li class="ml-6">
              <a
                :href="savedUrl"
                :class="[
                  'u-body-md group relative flex h-6 focus:outline-none',
                ]"
              >
                <span
                  :class="[
                    'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                  ]"
                ></span>
                <span class="mr-2 w-6 h-6">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-6 h-6"
                  >
                    <path
                      d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z"
                      class="group-hover:text-primary text-white fill-current transition duration-200 ease-in-out"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                      class="text-primary fill-current transition duration-200 ease-in-out"
                    />
                    <path
                      d="M21.7941 11.2602C20.189 9.57993 17.5871 9.57993 15.9989 11.2602C14.3939 9.57993 11.792 9.57993 10.2038 11.2602C8.59873 12.9405 8.59873 15.6643 10.2038 17.3269L15.3569 22.7214C15.7117 23.0929 16.3031 23.0929 16.6579 22.7214L21.811 17.3269C23.3991 15.6643 23.3991 12.9405 21.7941 11.2602Z"
                      class="text-primary group-hover:text-white fill-current transition duration-200 ease-in-out"
                    />
                  </svg>
                </span>
                <span
                  :class="[
                    'group-hover:border-primary border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out text-grey-800 group-hover:text-primary',
                  ]"
                >
                  Saved
                </span>
              </a>
            </li>
            <li class="ml-6">
              <a
                :href="searchUrl"
                :class="[
                  'u-body-md group relative inline-flex items-center h-6 focus:outline-none',
                ]"
              >
                <span
                  :class="[
                    'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                  ]"
                ></span>
                <span
                  :class="[
                    'group-hover:border-primary border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out text-grey-800 group-hover:text-primary',
                  ]"
                >
                  Search
                </span>
                <Sprite
                  id="icon-search"
                  class="ml-2 w-6 h-6 text-grey-700 group-hover:text-primary"
                />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import Sprite from '../../Sprite.vue';
export default {
  props: {
    navItems: {
      type: Array,
      required: true,
    },
    savedUrl: {
      type: String,
      required: true,
    },
    searchUrl: {
      type: String,
      required: true,
    },
  },
  components: {
    Sprite,
  },
};
</script>
